export const SET_USER_METADATA = "SET_USER_METADATA";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_ACCESS_KEY = "SET_ACCESS_KEY";
export const SET_IS_PROCESSED = "SET_IS_PROCESSED";


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/lib-postmessage/lib/actions/actionTypes.js